import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { DecisionState, HomeCalendarViewModel } from "../../../models/home";
import { LanguageService } from "../../../services/language/language.service";
import { formatDecisionTitle } from "../../../utils/decision-title-format.util";

@Component({
  selector: "app-home-decision-calendar-agenda",
  templateUrl: "./home-decision-calendar-agenda.component.html",
  styleUrls: ["./home-decision-calendar-agenda.component.scss"],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeDecisionCalendarAgendaComponent {
  @Input() viewModel: HomeCalendarViewModel | null = null;
  @Input() monthTitle = "";
  @Input() selectedDecisionId: string | null = null;
  @Output() monthNavigate = new EventEmitter<number>();
  @Output() todayRequest = new EventEmitter<void>();
  @Output() selectDecision = new EventEmitter<string>();
  readonly formatDecisionTitle = formatDecisionTitle;

  constructor(public readonly lang: LanguageService) {}

  get populatedDays() {
    return this.viewModel?.days.filter((day) => day.inCurrentPeriod && day.entries.length > 0) ?? [];
  }

  getStateLabel(state: DecisionState): string {
    return this.lang.translate(`home.decisionStates.${state}`);
  }

  getStateIconClass(state: DecisionState): string {
    const icons: Partial<Record<DecisionState, string>> = {
      act_now: "fa-bolt",
      act_soon: "fa-clock",
      waiting: "fa-pause-circle",
      completed: "fa-check-circle"
    };
    return icons[state] ?? "fa-info-circle";
  }

  trackDay(_: number, day: { dayKey: string }): string { return day.dayKey; }
  trackEntry(_: number, entry: { decisionId: string }): string { return entry.decisionId; }
}
